module.exports = __webpack_public_path__ + "static/img/ajax-loader.a90e737.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ajax-loader.gif
// module id = uS2h
// module chunks = 1